import { callApi } from "../api/fetch";
import { clearClientSession, isAuthSessionValid } from "./authSession";

/**
 * Performs complete logout:
 * 1. Calls logout API to log the event on the server
 * 2. Clears all client-side storage (localStorage)
 * 3. Clears authentication cookies
 */
export async function logout(options?: {
  redirectToLogin?: boolean;
  onComplete?: () => void;
}): Promise<void> {
  try {
    if (isAuthSessionValid()) {
      await callApi("/user/logout", {
        method: "POST",
      });
    }
  } catch (error) {
    console.error("Logout API error:", error);
  } finally {
    clearClientSession();
    options?.onComplete?.();
    if (options?.redirectToLogin) {
      window.location.href = "/login";
    }
  }
}
